module.exports = __webpack_public_path__ + "img/60ba106.jpg";